import { render } from "./ClientServicesSearchSection.vue?vue&type=template&id=51906e08"
import script from "./ClientServicesSearchSection.vue?vue&type=script&lang=js"
export * from "./ClientServicesSearchSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__